import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledPrimaryButton = styled.button`
    ${props => props.fullWidth && `width: 100%;`};
    font-size: ${props => props.theme.text.heading6.size};
    background-color: ${props => props.theme.colours.flat.blue.hex};
    color: ${props => props.theme.colours.flat.white.hex};
    border-radius: ${props => props.borderRadius};
    ${props => props.theme.shadowCss.rest()};
    padding: ${props => props.padding};
    border: 0;
    user-select: none;
    text-transform: uppercase;

    :hover {
        background-color: ${props => props.theme.colours.flat.darkBlue.hex};
        ${props => props.theme.shadowCss.elevated()};
    }

    :active {
        background-color: ${props => props.theme.colours.flat.darkBlue.hex};
        ${props => props.theme.shadowCss.elevated()}
    }

    :focus {
        outline: none;
    }

    :disabled {
        background-color: ${props => props.theme.colours.flat.gray.hex};
    }
`;

const PrimaryButton = ({ label, children, onClick, disabled, borderRadius, ...rest }) => (
    <StyledPrimaryButton {...rest} onClick={onClick} disabled={disabled} borderRadius={borderRadius}>
        {label}
        {children}
    </StyledPrimaryButton>
);

PrimaryButton.propTypes = {
    label: PropTypes.string,
    children: PropTypes.any,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    borderRadius: PropTypes.string,
    fullWidth: PropTypes.bool,
    padding: PropTypes.string
};

PrimaryButton.defaultProps = {
    borderRadius: "2em",
    fullWidth: false,
    padding: "0.8em 1em"
};

export default PrimaryButton;
